import React from 'react'
import Module from '~/components/Module'
import SVG from '~/components/SVG'
import TextToggle from '~/components/TextToggle'
import rewardIcon from '~/assets/icon-reward.svg'
import styles from './index.css'

const Reward = props => {
  const { awardsName, awardsNum, awardsDesc, awardsImg } = props

  return (
    <Module
      headerIcon={<SVG src={rewardIcon} width={14} height={14} />}
      headerText="奖励说明"
      contentClassName={styles.rewardContent}
    >
      <div className={styles.rewardDetail}>
        <div className={styles.rewardDes}>
          {awardsName && <div>奖品：{awardsName}</div>}
          {awardsNum && (
            <div className={styles.rewardCount}>数量：{awardsNum}个</div>
          )}
        </div>
        <TextToggle
          className={styles.content}
          content={awardsDesc}
          minLength={110}
        />
      </div>
      <img src={awardsImg} alt="" className={styles.rewardImg} />
    </Module>
  )
}

export default Reward



// WEBPACK FOOTER //
// ./src/modules/Reward/index.js